import Button from ".";
import styles from "./styles.module.scss";

interface SecondaryButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    
}

const SecondaryButton = ({ children, onClick }: SecondaryButtonProps) => {
    return (
        <Button type="default" className={styles.secondaryButton} onClick={onClick}>
            {children}
        </Button>
    )
}

export default SecondaryButton;